import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EmsServicesService } from 'src/app/module/ems-master/services/pms-services.service';
import { SharedService } from 'src/app/shared/shared.service';
import { WorklogService } from '../../services/worklog.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-add-worklog',
  templateUrl: './add-worklog.component.html',
  styleUrls: ['./add-worklog.component.css']
})
export class AddWorklogComponent {
  date: Date = new Date() ;
  date2: Date = new Date();
  createForm = new FormGroup({
    employeeId: new FormControl(null),
    projectId: new FormControl(null, Validators.required),
    logDate: new FormControl(''),
    start: new FormControl(),
    end: new FormControl(null),
    title: new FormControl(null, Validators.required),
    taskDescription: new FormControl(null),
    status: new FormControl(0),
    hr: new FormControl(''),
    min: new FormControl(''),
    minutes: new FormControl(''),
  })

  warehouseList: any;
  getWarehouseList: any;
  zone: any;
  accountList: any;
  accountMappingList:any;
  expenseAssociated: any;
  budgetType: any;
  financialYear: any;
  referenceList: any;
  warehouseTypeList: any;
  editTrue: boolean = true;
  editCalender: boolean = true;
  EditData: any;
  selectedFiles:any;
  progress = 0
  currentFile:any;
  message:any;
  @ViewChild('uploadInput') uploadInput!: ElementRef;
  allCatagory: any;
  expenseTypeList: any;
  multipleEdit = false;
  budgetProofURLs: any[]=[];
  ref: any;
  quickCodeCategoryList:any;

  projectLists:any[]=[];
  selectedLogDate: any;
  selectedStartTime: any;
  selectedEndTime: any;

  addCalender: boolean = true

  employeeId:any;
  @Input() parentForm!: FormGroup;
  formArray!: FormArray;
  dateTime = new Date();
  employeeProjectList:any[]=[];
  addProjectListModal = false
  selectedProjects:any[]=[];
  isSubmitted = false;
  constructor( private emsServices: EmsServicesService,
      public dialogService: DialogService,
       public dialogRef: DynamicDialogRef,
       public data: DynamicDialogConfig,
       public messageService: MessageService,
       public sharedService: SharedService,
      public WorklogService:WorklogService,
      private authService: AuthService,
    private datePipe: DatePipe){
     this.quickCodeCategoryList = JSON.parse(localStorage.getItem('category')!);
      this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!)

    this.editTrue =data?.data?.edit
    this.editCalender = data?.data?.editCalender
    this.addCalender = data?.data?.addCalender
   
    // const storedData = localStorage.getItem('employeeProjectMapping');
    // const employeeProjectMapping = storedData && storedData !== "undefined" ? JSON.parse(storedData) : [];
    // this.employeeProjectList = employeeProjectMapping
    const userDetails = JSON.parse(localStorage.getItem('user_details')!);
    this.employeeId = userDetails.id
    this.getEmployeeDetails(this.employeeId)
  }

  ngOnInit(): void {
    this.initForm();
  }

  getEmployeeDetails(employeeId:any){
    this.employeeProjectList = []
    this.authService.getEmployeeDetailsById(employeeId).subscribe((res:any)=>{
      this.employeeProjectList = res.responseObject?.employeeProjectMapping ? res.responseObject?.employeeProjectMapping : []
      this.getProjects()
    },(error:any)=>{
      this.employeeProjectList = []
      this.getProjects()
    })
  }

  private initForm(): void {
    this.formArray = new FormArray<FormGroup<any>>([]);
    this.parentForm = new FormGroup({
      worklogs: this.formArray
    });
    this.isSubmitted = false;
    if (this.editTrue || this.editCalender || this.addCalender) {
      this.bindEditData();
    } else {
        this.addForm('',''); 
    }
  }

  private bindEditData() {
    if (this.editTrue && this.data?.data?.editData) {
        const editData = this.data.data.editData;
        this.EditData = this.data.data.editData[0]
        this.formArray.clear(); // Clear existing entries

        editData.forEach((worklog:any) => {
            this.formArray.push(this.createWorklogFormGroup(worklog));
        });
    } 
    else if (this.editCalender && this.data?.data?.data) {
        this.data?.data?.data?.forEach((el:any)=>{
          el.id = el.publicId
        })
        const calendarData = this.data.data.data;
        this.EditData = this.data.data.data[0]
        this.formArray.clear();

        calendarData.forEach((event:any) => {
            this.formArray.push(this.createWorklogFormGroup(event.extendedProps, event.publicId,event.title));
        });
    } 
    else if (this.data?.data?.selectedDate && this.data?.data?.addCalender) {
            this.formArray.clear();

            this.formArray.push(this.createWorklogFormGroup({
                logDate: this.data.data.selectedDate,
                start: this.data?.data?.startDateTime,
                end: this.data.data.endDateTime
            }));
        }
    }

    private parseDateTime(dateTime: any): Date | null {
      if (!dateTime) return null;
  
      // Check if dateTime is already a Date object
      if (dateTime instanceof Date) {
          return dateTime;
      }
  
      // Check if dateTime is in DD-MM-YYYY HH:mm:ss Z format
      if (/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2} [+-]\d{4}$/.test(dateTime)) {
          return moment(dateTime, "DD-MM-YYYY HH:mm:ss Z").toDate();
      }
  
      // Check if dateTime is in ISO format (YYYY-MM-DDTHH:mm:ss)
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateTime)) {
          return new Date(dateTime);
      }
  
      return null;
  }

  formatTo12HourTime(dateTime:any) {
    // Convert to Date object if necessary
    if (!(dateTime instanceof Date)) {
        if (/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2} [+-]\d{4}$/.test(dateTime)) {
            // Parse 'DD-MM-YYYY HH:mm:ss Z' format using moment.js
            dateTime = moment(dateTime, "DD-MM-YYYY HH:mm:ss Z").toDate();
        } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateTime)) {
            // Parse ISO format (YYYY-MM-DDTHH:mm:ss)
            dateTime = new Date(dateTime);
        } else {
            throw new Error("Invalid date format");
        }
    }

    // Extract hours and minutes
    let hours = dateTime.getHours();
    let minutes = dateTime.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";

    // Convert 24-hour time to 12-hour format
    hours = hours % 12 || 12; // Convert 0 (midnight) to 12

    // Ensure two-digit minutes
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes} ${ampm}`;
}

getTimeFromDateTime(datetime: any): string {
  if (!datetime) return '';

  const dtString = String(datetime); // Ensure it's a string
  let date: Date;

  // Case 1: ISO or JS-compatible formats
  if (dtString.includes('T') || dtString.includes('GMT')) {
    date = new Date(dtString);
    if (isNaN(date.getTime())) return ''; // Invalid date
  }
  // Case 2: Custom format "19-03-2025 14:39:00 +0530"
  else {
    const match = dtString.match(/^(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2}) ([\+\-]\d{4})$/);
    if (match) {
      const [_, day, month, year, time, offset] = match;
      const isoString = `${year}-${month}-${day}T${time}${offset}`;
      date = new Date(isoString);
    } else {
      return ''; // Unrecognized format
    }
  }

  // Extract HH:mm:ss
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}



  createWorklogFormGroup(data: any, publicId?: any,title?:any): FormGroup {
    const hourMinutes = this.sharedService.convertToHoursAndMinutes(data.minutes) 
    return new FormGroup({
        id: new FormControl(publicId || data?.id || null),
        projectId: new FormControl(data?.projectId || '', Validators.required),
        logDate: new FormControl(this.parseDateTime(data?.logDate), Validators.required),
        start: new FormControl(this.getTimeFromDateTime(data?.start || data?.startDate)),
        end: new FormControl(null),
        title: new FormControl(data?.title || title || '',Validators.required),
        taskDescription: new FormControl(data?.taskDescription || ''),
        hr: new FormControl(hourMinutes?.hours || ''),
        min: new FormControl(hourMinutes?.minutes || ''),
        minutes: new FormControl(data?.minutes || ''),
        // status: new FormControl(data?.status || '')
    });
}
  
submitData(formGroup:any,i:any){
  if(formGroup){
    this.parentForm.value.worklogs = this.parentForm.value.worklogs.filter((el:any)=>{
      if(el.title === formGroup.value.title && el.taskDescription === formGroup.value.taskDescription && el?.start === formGroup.value?.start){
        return el
      }
    })
    this.isSubmitted = true
    this.submitForm2(i)
  }
}

  addForm(formGroup:any,i:any): void {
    const worklogForm = new FormGroup({
      id: new FormControl(null),
      employeeId: new FormControl(null),
      projectId: new FormControl(null, Validators.required),
      logDate: new FormControl('', Validators.required),
      start: new FormControl(''),
      end: new FormControl(null),
      title: new FormControl('', Validators.required),
      taskDescription: new FormControl(''),
      hr: new FormControl(''),
      min: new FormControl(''),
      minutes: new FormControl('')
    });
    if(!this.editTrue && !this.editCalender){
      this.formArray.push(worklogForm);
    }
    console.log(formGroup,i,'<-------------formGroup')
    if(formGroup){
      this.parentForm.value.worklogs = this.parentForm.value.worklogs.filter((el:any)=>{
        if(el.title === formGroup.value.title && el.taskDescription === formGroup.value.taskDescription && el?.start === formGroup.value?.start){
          return el
        }
      })
      
      this.submitForm2(i)
    }
  }

  removeForm(index: number): void {
    if (this.formArray.length > 1) {
      this.formArray.removeAt(index);
    }
  }

  setLogDate2(event: any, index: number): void {
    const control = this.formArray.at(index).get('logDate');
    if (control) {
      control.setValue(event);
    }
  }

  selectTime2(event: any, index: number, type: string): void {
    const control = this.formArray.at(index).get(type);
    if (control) {
      control.setValue(event);
    }
  }

  submitForm2(i:any) {
    const formValues: { worklogs: any[] } = { ...this.parentForm.value };

    const processedWorklogs = formValues.worklogs.map((worklog) => {
        let processedWorklog = { ...worklog };

        if (processedWorklog['start']) {
          let startTime = moment(processedWorklog['start'], ["h:mm A", "HH:mm"]).format("HH:mm:ss Z");
          startTime = startTime.replace(/(\+\d{2}):(\d{2})/, "$1$2");
          processedWorklog['start'] = this.datePipe.transform(processedWorklog['logDate'], 'dd-MM-yyyy') + ' ' + startTime;
      }

        if (processedWorklog['end']) {
            let endTime = moment(processedWorklog['end']).format('HH:mm:ss Z');
            endTime = endTime.replace(/(\+\d{2}):(\d{2})/, "$1$2");
            processedWorklog['end'] = this.datePipe.transform(processedWorklog['logDate'], 'dd-MM-yyyy') + ' ' + endTime;
        }

        if (processedWorklog['logDate']) {
            let logTime = moment(processedWorklog['logDate']).format('HH:mm:ss Z');
            logTime = logTime.replace(/(\+\d{2}):(\d{2})/, "$1$2");
            processedWorklog['logDate'] = this.datePipe.transform(processedWorklog['logDate'], 'dd-MM-yyyy') + ' ' + logTime;
        }

        if(processedWorklog['hr'] || processedWorklog['min']){
          processedWorklog['minutes'] = this.sharedService.convertToMinutes(processedWorklog['hr'],processedWorklog['min'])
        }

        delete processedWorklog['hr'];
        delete processedWorklog['min'];

        return processedWorklog;
    });

    const employeeId = this.employeeId;
    let payload = processedWorklogs.length > 0 ? processedWorklogs : [];
    if (this.editTrue || this.editCalender) {
        payload = payload.map((worklog, index) => {
            let updatedWorklog = { ...worklog, employeeId: this.employeeId };
            if (index === 0 && this.EditData?.id) {
                updatedWorklog.id = this.EditData.id;
            } else {
                delete updatedWorklog.id;
            }
    
            return updatedWorklog;
        });
    } else {
        payload = payload.map(worklog => ({
            ...worklog,
            employeeId: this.employeeId
        }));
    }

    console.log("Final Payload:", payload);

    this.WorklogService.addMultiWorklogs(payload).subscribe((data: any) => {
        if (data) {
          const worklogsArray = this.parentForm.get('worklogs') as FormArray;
          const formToDisable = worklogsArray.at(i) as FormGroup;
          Object.keys(formToDisable.controls).forEach((key) => {
            formToDisable.get(key)?.disable();
          });
          if(this.editTrue || this.editCalender || this.isSubmitted){
            this.dialogRef.close(data);
          }  
          else{
            this.parentForm.value.worklogs[i].disable()
          }
        }
    },(error:any)=>{
      if(!this.isSubmitted){
        const worklogsArray = this.parentForm.get('worklogs') as FormArray;
        if (worklogsArray.length > 0) {
          worklogsArray.removeAt(worklogsArray.length - 1);
        }
      }
      this.isSubmitted = false 
    });
}

  patchEditData(): void {
    if (this.editTrue || this.editCalender) {
      this.parentForm.patchValue({
        id: this.EditData?.id
      });
    }
  }
  
  getProjects() {
    this.emsServices
      .getProjects([], 0, 50000, 'Id', 'DESC')
      .subscribe((data: any) => {
        if (data?.responseObject?.content) {
          if(data.responseObject?.content?.length > 0){
            data.responseObject.content.forEach((el:any)=>{
              el.projectId = el.id
            })
            if(this.editTrue){
            const projectIds = new Set(this.employeeProjectList?.map((el:any) => el.projectId));
            const hasProjectId = !projectIds.has(this.EditData.projectId)
            console.log(hasProjectId)
            data.responseObject.content.forEach((el:any)=>{
                if(hasProjectId){
                  if(el.projectId === this.EditData.projectId){
                    this.selectedProjects.push(el)
                    this.addAdditionProject()
                  }
                }
              })
            }
          }
          const projectList = data.responseObject.content;
          const employeeProjectIds = new Set(this.employeeProjectList?.map((emp:any) => emp.projectId));
          this.projectLists = projectList.filter((project:any) => !employeeProjectIds.has(project.id));
        } else {
          this.projectLists = [];
        }
      }, err => {
        this.projectLists = [];
      });
  }

  addAdditionProject(){
    if (this.selectedProjects && this.selectedProjects.length > 0) {
      this.selectedProjects.forEach((project:any) => {
        this.employeeProjectList.push(project);
      });
      this.projectLists = this.projectLists.filter(project => !this.selectedProjects.includes(project));
      const worklogs = this.parentForm.get('worklogs') as FormArray;
      worklogs.controls.forEach((control) => {
        if (!control.get('projectId')?.value) {
          control.patchValue({ projectId: this.selectedProjects[0].projectId });
        }
      });
      this.selectedProjects = [];
      this.addProjectListModal = false;
    }
  }

  copy(formGroup: any, i: any) {
    const worklogsArray = this.parentForm.get('worklogs') as FormArray;
    
    if (worklogsArray.length < 2) {
      console.warn("Not enough worklogs to copy from.");
      return;
    }
  
    // Get second last worklog data
    const secondLastIndex = worklogsArray.length - 2;
    const lastIndex = worklogsArray.length - 1;
  
    const secondLastWorklog = worklogsArray.at(secondLastIndex).value;
    
    // Patch the last worklog with the second last worklog's values
    worklogsArray.at(lastIndex).patchValue(secondLastWorklog);
  }

  focus(event:any){
    event.target.select()
  }

}
